import { Component, Input } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { BaseComponent } from '../../shared/base-components/base.component';
import { DocumentLaunchContext, DocumentLaunchModalComponent } from '../../shared/components/document/document-launch-modal.component';
import { BusinessTransactionHistorySearchCriteria } from '../../shared/models/business-transaction/business-transaction-history-search-criteria.model';
import { BusinessTransactionHistorySearchResults } from '../../shared/models/business-transaction/business-transaction-history-search-results.model';
import { DocumentItemKeyData } from '../../shared/models/document/document-itemkey.model';
import { BusinessTransactionService } from '../../shared/services/business-transaction/business-transaction.service';
import { ModalSize } from '../../shared/services/modal/mvd-modal.enum';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { ArtifactContext, ArtifactModalComponent } from '../../transaction/artifact/artifact-modal.component';
import { WIPStatusType } from '../../wip/models/enums/w-i-p-status-type.enum';

@Component({
    selector: 'service-history-results',
    templateUrl: './service-history-results.html'
})

export class ServiceHistoryResultsComponent extends BaseComponent {
    @Input() public searchCriteria: BusinessTransactionHistorySearchCriteria;
    @Input() public rows = 10;
    @Input() public filterEnabled = true;
    @Input() public hideActions = false;
    @Input() public componentTitle = 'Service History Results';

    public customerServiceHistorysearchResults: BusinessTransactionHistorySearchResults[] = [];
    public wipStatusType: WIPStatusType = new WIPStatusType();
    public documentUploadItems: DocumentItemKeyData[] = [];
    public dataStore: any = [];
    private previousOrder: number;
    private previousSort = '';
    private previousPageNumber = -1;
    public totalRecords: number;
    public inProgress: boolean;

    // Gets or sets the business unit list
    public businessUnits: any[];

    // Gets or sets the business transaction type list
    public businessTransactionTypes: any[];

    // Gets or sets the columns for the data table
    public cols = [
        { field: 'receiptId', header: 'Receipt Number' },
        { field: 'businessTransactionCompletionDate', header: 'Service Completion Date' },
        { field: 'businessUnit', header: 'Location' },
        { field: 'businessTransactionType', header: 'Service' },
        { field: 'businessTransactionDetails', header: 'Details' },
        { field: 'agentName', header: 'Agent' },
        { field: 'customerName', header: 'Customer' },
        { field: 'amount', header: 'Amount' }
    ];

    constructor(
        private businessTransactionService: BusinessTransactionService,
        public modalService: MvdModalService) {
        super();
    }

    async ngOnInit() {

        this.inProgress = true;

        this.populateSearchResults();

        this.inProgress = false;
    }

    /**
     * Reset pagination settings
     */
    public resetPagination(): void {
        this.dataStore = [];
        this.previousPageNumber = -1;
        this.totalRecords = 0;
    }

    search() {
        this.resetPagination();
        this.populateSearchResults();
    }

    loadDataLazy(event: LazyLoadEvent) {
        this.populateSearchResults(event);
    }

    populateSearchResults(event: LazyLoadEvent = { rows: this.rows, first: 0, sortOrder: 0 }) {
        if (this.searchCriteria) {

            this.searchCriteria.lazyLoadEvent = event;

            // Set page load in progress
            this.inProgress = true;

            // Calculate the current page used for determing if we are going to load from the data store or fetch data
            const pageNumber = Math.floor(event.first / this.rows);

            // if all the sorting is the same and we are on a previous page then just reload from the data store
            // otherwise go fetch data
            if (this.previousSort == event.sortField && this.previousOrder == event.sortOrder && this.previousPageNumber >= pageNumber) {
                this.displaySearchResults(event);
            } else {
                this.businessTransactionService.searchBusinessTransactionHistoryForCustomer(this.searchCriteria)
                    .subscribe(result => {
                        // Splice these into the data store in case this is a change for sorting
                        // so the existing records will be kept
                        this.dataStore.splice(event.first, event.rows, ...result.result);

                        // calculate the total records used by the grid if we new data coming in.
                        if (result.result.length > 0) {
                            this.totalRecords = (pageNumber + 1) * this.rows + 1;
                        }

                        this.displaySearchResults(event);
                    },
                    error => {
                        this.customerServiceHistorysearchResults = null;
                        this.inProgress = false;
                        this.handleValidationResult(error);
                    });
            }

            // Set our previous page information
            this.previousPageNumber = pageNumber;
            this.previousSort = event.sortField;
            this.previousOrder = event.sortOrder;
        }
    }

    private displaySearchResults(event: LazyLoadEvent) {
        this.customerServiceHistorysearchResults = [];
        this.inProgress = false;
        // Slice the results and apply the current filter.
        this.customerServiceHistorysearchResults = this.dataStore.slice(event.first, (event.first + event.rows));
        this.customerServiceHistorysearchResults = this.customerServiceHistorysearchResults.filter(row => this.filterGlobal(row, event.globalFilter));
    }

    public filterGlobal(row, value) {
        for (let i = 0; i < this.cols.length; i++) {
            let column: any = this.cols[i];
            if (row[column.field] == null) {
                continue;
            }
            let rowValue: String = row[column.field].toString().toLowerCase();
            if (value == null || rowValue.includes(value.toLowerCase())) {
                return true;
            }
        }
        return false;
    }

    getArtifacts(businessTransactionNumber: number, details: string) {
        const data = new ArtifactContext(businessTransactionNumber, details);
        this.modalService.open(ArtifactModalComponent, data, ModalSize.Medium);
    }

    retryCompleteBusinessTransaction(transaction: BusinessTransactionHistorySearchResults) {
        transaction.wipStatusTypeId = null;
        this.businessTransactionService.completeBusinessTransaction(transaction.businessTransactionNumber)
            .subscribe(result => {
                // Wait for completionResponse$ event to be fired for the transaction.
            },
            err => {
            });
    }

    public launchDocuments(businessTransactionNumberId: number) {
        var item = new DocumentItemKeyData();
        item.documentItemKeyTypeId = 7;
        item.itemKeyId = businessTransactionNumberId;
        this.documentUploadItems.push(item);

        let data = new DocumentLaunchContext(this.documentUploadItems);

        // open the modal
        this.modalService.open(DocumentLaunchModalComponent, data)
            .afterClosed()
            .subscribe(() => { });
    }
}
